import { render, staticRenderFns } from "./MentionsOverTime.vue?vue&type=template&id=b6c54616"
import script from "./MentionsOverTime.vue?vue&type=script&lang=js"
export * from "./MentionsOverTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports